export default "__VITE_ASSET__Cq3fGth9__"